import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0A0A0A] text-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
